// webhookTemplatesData
// Stores JSON data structure representing different integration webhook templates
export default {
    wcf_custom_ping: {
        fields: {
            output_tag_prefix: 'webhook_output_12345',

            ping_url: 'https://example.com/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: ""
        },
        template_summary: {
            template_summary_text: ""
        },
        template_steps: {
            template_steps_text: ""
        },
        template_required_parameters: []
    },
    wcf_custom_ping_post: {
        fields: {
            output_tag_prefix: 'webhook_output_12345',

            ping_url: 'https://example.com/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: 'placeholder',
            post_condition_operator: 'is_equal',
            post_condition_value: 'true',

            post_url: 'https://example.com/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{}',
            post_output_map: '{"PostOutputMap":{}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: ""
        },
        template_summary: {
            template_summary_text: ""
        },
        template_steps: {
            template_steps_text: ""
        },
        template_required_parameters: []
    },
    tld_agent_availability: {
        fields: {
            output_tag_prefix: 'tld_12345',

            ping_url: 'https://TEMPLATE_URL.tldcrm.com/api/public/dialer/ready/[nanp_caller_number]?ava=1&ing=99999',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"ready":"ready"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_ready' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TLD Agent Availability API to request a numeric 'ready' response value representing the number of agents ready to take a call. If the 'ready' response value is above 0, Retreaver will open the TLD integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TLD integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TLD.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "tld_url",
                property_name: "TLD API Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.tldcrm.com/api/public/dialer/ready/"
            },
            {
                property_id: "tld_ing",
                property_name: "TLD 'ing' URL Parameter Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "99999"
            }
        ]
    },
    ringba_rtb_ping_post: {
        fields: {
            output_tag_prefix: 'ringba_12345',

            ping_url: 'https://rtb.ringba.com/v1/production/TEMPLATE_RTB_ID.json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"CID":"[nanp_caller_number]","state":"[caller_state]","zipCode":"[caller_zip]","exposeCallerId":"yes"}',
            ping_output_map: '{"PingOutputMap":{"number":"phoneNumber","bid":"bidAmount","timer":"bidTerms[0].callMinDuration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Ringba RTB API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the RTB request returns a valid transfer number, Retreaver will open the Ringba RTB integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Ringba RTB integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Ringba.\n\n3) Optionally, update the 'Ping Data' field if you would like to submit additional caller data along with the request.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "rtb_id",
                property_name: "Ringba RTB ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_RTB_ID"
            }
        ]
    },
    track_drive_ping_post: {
        fields: {
            output_tag_prefix: 'trackdrive_12345',

            ping_url: 'https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/ping/TEMPLATE_URL?trackdrive_number=+18551231234&traffic_source_id=4444&caller_id=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"status":"status","ping_id":"buyers[0].ping_id","timer":"buyers[0].offer_conversion_duration","bid":"buyers[0].offer_conversion_payout"}}',

            post_condition_key: 'status',
            post_condition_operator: 'is_equal',
            post_condition_value: 'accepted',

            post_url: 'https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/post/TEMPLATE_URL?trackdrive_number=+18551231234&traffic_source_id=4444&caller_id=[nanp_caller_number]&ping_id=<podd_start>ping_id<podd_end>',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '{}',
            post_output_map: '{"PostOutputMap":{"forwarding_number_status":"forwarding_number_status","number":"forwarding_number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TrackDrive API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the TrackDrive request returns a valid transfer number, Retreaver will open the TrackDrive integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TrackDrive integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TrackDrive, update the 'TEMPLATE_URL' and then update the 'trackdrive_number' and 'traffic_source_id' url parameters with the values provided by TrackDrive.\n\n3) Update the 'Post URL' field to match with the instructions provided by TrackDrive, update the 'TEMPLATE_URL' and then update the 'trackdrive_number' and 'traffic_source_id' url parameters with the values provided by TrackDrive.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "trackdrive_ping_url",
                property_name: "TrackDrive Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/ping/TEMPLATE_URL"
            },
            {
                property_id: "trackdrive_post_url",
                property_name: "TrackDrive Post URL",
                fields_to_replace: [
                    "post_url"
                ],
                replacement_token: "https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/post/TEMPLATE_URL"
            },
            {
                property_id: "trackdrive_number",
                property_name: "TrackDrive Number",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "+18551231234"
            },
            {
                property_id: "traffic_source_id",
                property_name: "TrackDrive Source ID",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "4444"
            },
            {
                property_id: "timer_output_tag",
                property_name: "TrackDrive Conversion Timer Output Key",
                fields_to_replace: [
                    "ping_output_map"
                ],
                replacement_token: "offer_conversion_duration OR current_conversion_duration"
            }
        ]
    },
    enhance_availability: {
        fields: {
            output_tag_prefix: 'enhance_agent_12345',

            ping_url: 'https://availability.enhance.tools/api/v1/call?api=TEMPLATE_API_KEY&phone=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"ok":"ok","available":"available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Enhance Agent Availability API to request a boolean 'available' response value representing if an agent is available to take a call. If the 'available' response equals 'true', Retreaver will open the Enhance integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Enhance integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Enhance.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Enhance API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ]
    },
    convoso_availability_agent_monitor: {
        fields: {
            output_tag_prefix: 'consovo_12345',

            ping_url: 'https://api.convoso.com/v1/agent-monitor/search?auth_token=TEMPLATE_AUTH_TOKEN&queue_id=12345&campaign_id=67890',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"available_agents":"data.available_agents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'greater_than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Convoso Agent Availability API to request a numeric 'available_agents' response value representing if an agent is available to take a call. If the 'available_agents' response is greater than '0', Retreaver will open the Convoso integrated buyer for routing.\n\nNOTE: This API endpoint returns a large output response message, we recommend that you use the 'user-activity' API variant instead which must first be enabled by the Convoso account managers."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Convoso integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Convoso.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Convoso API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://api.convoso.com/v1/agent-monitor/search?auth_token=TEMPLATE_AUTH_TOKEN&queue_id=12345&campaign_id=67890"
            }
        ]
    },
    convoso_availability_user_activity: {
        fields: {
            output_tag_prefix: 'consovo_12345',

            ping_url: 'https://api.convoso.com/v1/user-activity/search?auth_token=TEMPLATE_AUTH_TOKEN&queue_id=12345&campaign_id=67890',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"available_agents":"data.available_agents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'greater_than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Convoso Agent Availability API to request a numeric 'available_agents' response value representing if an agent is available to take a call. If the 'available_agents' response is greater than '0', Retreaver will open the Convoso integrated buyer for routing.\n\nNOTE: This API endpoint is the optimized version of the 'agent-monitor' API endpoint, however please ensure that it has been enabled by the Convoso account managers first prior to implementing it on your Retreaver buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Convoso integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Convoso.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Convoso API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://api.convoso.com/v1/user-activity/search?auth_token=TEMPLATE_AUTH_TOKEN&queue_id=12345&campaign_id=67890"
            }
        ]
    },
    leadspedia_ping_post: {
        fields: {
            output_tag_prefix: 'leadspedia_12345',

            ping_url: 'https://TEMPLATE_URL.leadspediatrack.com/call-ping.do?lp_campaign_id=TEMPLATE_CAMPAIGN_ID&lp_campaign_key=TEMPLATE_CAMPAIGN_KEY&caller_id=[nanp_caller_number]&zip_code=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"status":"status","request_number_url":"request_number_url"}}',

            post_condition_key: 'status',
            post_condition_operator: 'is_equal',
            post_condition_value: 'Accepted',

            post_url: '<podd_start>request_number_url<podd_end>',
            post_method: 'GET',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '{}',
            post_output_map: '{"PostOutputMap":{"number":"number","timer":"duration","bid":"payout"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Leadspedia API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Leadspedia request returns a valid transfer number, Retreaver will open the Leadspedia integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Leadspedia integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Leadspedia, update the 'TEMPLATE_URL' and then update the 'TEMPLATE_CAMPAIGN_ID' and 'TEMPLATE_CAMPAIGN_KEY' url parameters with the values provided by Leadspedia.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "leadspedia_ping_url",
                property_name: "Leadspedia Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.leadspediatrack.com/call-ping.do"
            },
            {
                property_id: "leadspedia_campaign_id",
                property_name: "Leadspedia Campaign ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "leadspedia_campaign_key",
                property_name: "Leadspedia Campaign Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_KEY"
            }
        ]
    },
    integriant_availability: {
        fields: {
            output_tag_prefix: 'integriant_12345',

            ping_url: 'https://api.integriant.com/call-transfers?partner_name=TEMPLATE_PARTNER_NAME&phone=[nanp_caller_number]&zipcode=[caller_zip]&state=[caller_state]&platform=b&vertical=u65',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{"phone":"[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{"agents_available":"agentsAvailable"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_agents_available' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Integriant Agent Availability API to request a boolean 'agents_available' response value representing if an agent is available to take a call. If the 'agents_available' response equals 'true', Retreaver will open the Integriant integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Integriant integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Integriant, update the 'TEMPLATE_PARTNER_NAME' url parameter.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "partner_name",
                property_name: "Integriant Partner Name",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PARTNER_NAME"
            },
            {
                property_id: "vertical",
                property_name: "Integriant Vertical",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "u65"
            }
        ]
    },
    connie_health_ping_post: {
        fields: {
            output_tag_prefix: 'connie_health_12345',

            ping_url: 'https://calls-api-prod.conniehealth.com/partner-calls/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"partnerUuid":"TEMPLATE_PARTNER_UUID","customerZip":"[caller_zip]","customerGender":"[TEMPLATE_GENDER_TAG]","optin":"true"}',
            ping_output_map: '{"PingOutputMap":{"pingId":"pingId","status":"status","statusReason":"statusReason"}}',

            post_condition_key: 'status',
            post_condition_operator: 'is_equal',
            post_condition_value: 'accepted',

            post_url: 'https://calls-api-prod.conniehealth.com/partner-calls/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"pingId":"<podd_start>pingId<podd_end>","customerPhoneNumber":"[nanp_caller_number]"}',
            post_output_map: '{"PostOutputMap":{"post_pingId":"pingId","post_status":"status","post_statusReason":"statusReason","payoutInCents":"payoutInCents","number":"phoneNumber","timer":"requiredCallDuration","bid":"payoutInCents"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: 'bid',
            revshare_modifier_percentage: '0.01'
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Connie Health API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Connie Health request returns a valid transfer number, Retreaver will open the Connie Health integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Connie Health integrated buyer.\n\n2) Update the 'TEMPLATE_PARTNER_UUID' and then update the 'TEMPLATE_GENDER_TAG' values in the 'Ping Data' field with the values provided by Connie Health.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "partner_uuid",
                property_name: "Connie Partner UUID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_PARTNER_UUID"
            },
            {
                property_id: "gender_value",
                property_name: "Caller Gender Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_GENDER_TAG]"
            }
        ]
    },
    jangl_ping_post: {
        fields: {
            output_tag_prefix: 'jangl_12345',

            ping_url: 'https://calls-api.jangl.com/v1/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Token TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"caller_phone":"[caller_number]","contact":{"state":"[caller_state]","zip_code":"[caller_zip]"}}',
            ping_output_map: '{"PingOutputMap":{"call_id":"call_id","bid_id":"bid.bid_id","bid":"bid.payout","timer":"bid.purchase_duration","transfer_name":"bid.transfer_name","success":"success"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://calls-api.jangl.com/v1/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","Authorization":"Token TEMPLATE_AUTHORIZATION_TOKEN"}',
            post_data: '{"caller_phone":"[caller_number]","bid_id":"<podd_start>bid_id<podd_end>","contact":{"state":"[caller_state]","zip_code":"[caller_zip]"}}',
            post_output_map: '{"PostOutputMap":{"number":"phone_number","success":"success"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Jangl API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Jangl request returns a valid transfer number, Retreaver will open the Jangl integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Jangl integrated buyer.\n\n2) Update the 'Ping Headers' and 'Post Headers' TEMPLATE_AUTHORIZATION_TOKEN value to match with the values provided by Jangl.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "authorization_token",
                property_name: "Jangl Authorization Token",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ]
    },
    media_alpha_ping_post: {
        fields: {
            output_tag_prefix: 'media_alpha_12345',

            ping_url: 'https://insurance.mediaalpha.com/call-transfers-ping.json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"api_token":"TEMPLATE_API_TOKEN","call_type":"Inbound","data":{"zip":"[caller_zip]"},"ip":"","local_hour":12,"max":3,"placement_id":"TEMPLATE_PLACEMENT_ID","sub_1":"","transfer_type":"cold","ua":"","url":"","version":17}',
            ping_output_map: '{"PingOutputMap":{"ping_bid_id":"call_transfers[0].bid_id","ping_ping_id":"ping_id","ping_error":"error"}}',

            post_condition_key: 'ping_bid_id',
            post_condition_operator: 'exists',
            post_condition_value: '',

            post_url: 'https://insurance.mediaalpha.com/call-transfers-post.json',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"api_token":"TEMPLATE_API_TOKEN","bid_id":"<podd_start>ping_bid_id<podd_end>","call_type":"Outbound","data":{"zip":"[caller_zip]"},"ip":"","local_hour":12,"ping_id":"<podd_start>ping_ping_id<podd_end>","placement_id":"TEMPLATE_PLACEMENT_ID","transfer_type":"cold","url":"","version":17}',
            post_output_map: '{"PostOutputMap":{"bid":"bid","timer":"qualification_duration","number":"phone_num","post_error":"error"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Media Alpha API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Media Alpha request returns a valid transfer number, Retreaver will open the Media Alpha integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Media Alpha integrated buyer.\n\n2) Update the 'TEMPLATE_API_TOKEN' and then update the 'TEMPLATE_PLACEMENT_ID' values in the 'Ping Data' and 'Post Data' fields with the values provided by Media Alpha.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_token",
                property_name: "Media Alpha API Token",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_API_TOKEN"
            },
            {
                property_id: "placement_id",
                property_name: "Media Alpha Placement ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_PLACEMENT_ID"
            }
        ]
    },
    lead_api_px_ping_post: {
        fields: {
            output_tag_prefix: 'leads_api_px_12345',

            ping_url: 'https://leadapi.px.com/api/call/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Accept":"application/json"}',
            ping_data: '{"ApiToken":"TEMPLATE_API_TOKEN","Vertical":"TEMPLATE_VERTICAL","SubId":"TEMPLATE_SUB_ID","OfferId":"TEMPLATE_OFFER_ID","OriginalUrl":"Not applicable","ContactData":{"PhoneNumber":"[caller_number]","ZipCode":"[caller_zip]"}}',
            ping_output_map: '{"PingOutputMap":{"ping_TransactionId":"TransactionId","ping_Success":"Success","bid":"Payout","ping_Sold":"Sold"}}',

            post_condition_key: 'ping_Success',
            post_condition_operator: 'is_equal',
            post_condition_value: 'true',

            post_url: 'https://leadapi.px.com/api/call/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","Accept":"application/json"}',
            post_data: '{"TransactionId":"<podd_start>ping_TransactionId<podd_end>","ApiToken":"TEMPLATE_API_TOKEN","Vertical":"TEMPLATE_VERTICAL","SubId":"TEMPLATE_SUB_ID","OfferId":"TEMPLATE_OFFER_ID","OriginalUrl":"Not applicable","ContactData":{"ZipCode":"[caller_zip]","PhoneNumber":"[caller_number]"}}',
            post_output_map: '{"PostOutputMap":{"post_TransactionId":"TransactionId","post_Success":"Success","post_payout":"Payout","post_Sold":"Sold"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Seconds Tag' field, set the value to a hardcoded value to match with your affiliate partner agreement.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Scroll to the 'Tag List' section, then press the 'wizard' button.\n\n6) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_bid' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n7) Press 'add' on the tag wizard.\n\n8) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Lead PX API to request for a potential conversion bid. If the Lead PX request returns a valid conversion bid, Retreaver will open the Lead PX integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Lead PX integrated buyer.\n\n2) Update the 'Ping Data' and 'Post Data' fields including:\nTEMPLATE_API_TOKEN\nTEMPLATE_VERTICAL\nTEMPLATE_SUB_ID\nTEMPLATE_OFFER_ID\nMake sure to match with the instructions provided by Lead PX.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_token",
                property_name: "Lead PX API Token",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_API_TOKEN"
            },
            {
                property_id: "vertical",
                property_name: "Lead PX Vertical",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_VERTICAL"
            },
            {
                property_id: "sub_id",
                property_name: "Lead PX Sub ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SUB_ID"
            },
            {
                property_id: "offer_id",
                property_name: "Lead PX Offer ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_OFFER_ID"
            }

        ]
    },
    apolloi_leads_ping: {
        fields: {
            output_tag_prefix: 'apollo_12345',

            ping_url: 'https://health.apolloileads.com/calls/post/health/TEMPLATE_SOURCE.json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Basic TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"telephone":"[nanp_caller_number]","lead_type":"I"}',
            ping_output_map: '{"PingOutputMap":{"bid":"payout","number":"destination_phone_number","timer":"billable_duration","transaction_id":"transaction_id","message":"message"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the ApolloiLeads API to request for a potential conversion bid. If the ApolloiLeads request returns a valid conversion bid, Retreaver will open the ApolloiLeads integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the ApolloiLeads integrated buyer.\n\n2) Update the 'Ping Url's 'TEMPLATE_SOURCE' field using the instructions provided by ApolloiLeads.\n\n3) Update the 'Ping Header's 'TEMPLATE_AUTHORIZATION_TOKEN' with the value provided by ApolloiLeads.\n\n4) Update the 'Ping Data' lead_type field, using 'I' for health, or 'S' for medicare verticals.\n\n5) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Apollo API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://health.apolloileads.com/calls/post/health/TEMPLATE_SOURCE.json"
            },
            {
                property_id: "authorization_token",
                property_name: "Apollo Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ]
    },
    zoho_data_post: {
        fields: {
            output_tag_prefix: 'zoho_12345',

            ping_url: 'https://connect.zoho.com/function/api/TEMPLATE_USER_ID/TEMPLATE_USER_PROJECT?zapikey=TEMPLATE_ZAPIKEY',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"First_Name":"[first_name]","Last_Name":"[last_name]","Phone":"[nanp_caller_number]","Email":"[email]","City":"[caller_city]","State":"[caller_state]","Zip_Code":"[caller_zip]","Currently_Covered":"yes","Lead_Source":"TEMPLATE_SOURCE","Lead_Type":"TEMPLATE_LEAD_TYPE"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to Zoho's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Zoho integrated buyer.\n\n2) Update the 'Ping Url' using the instructions provided by Zoho, be sure to replace the TEMPLATE_USER_ID, TEMPLATE_USER_PROJECT and TEMPLATE_ZAPIKEY values with the values provided by Zoho.\n\n3) Update the 'Ping Data' fields to include any required values you wish to pass. Make sure you also update the 'TEMPLATE_SOURCE' and 'TEMPLATE_LEAD_TYPE' fields to match with the instructions provided by Zoho.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Zoho API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://connect.zoho.com/function/api/TEMPLATE_USER_ID/TEMPLATE_USER_PROJECT"
            },
            {
                property_id: "zapi_key",
                property_name: "Zoho ZAPI Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ZAPIKEY"
            },
            {
                property_id: "lead_source",
                property_name: "Zoho Lead Source",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            },
            {
                property_id: "lead_type",
                property_name: "Zoho Lead Type",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_LEAD_TYPE"
            }
        ]
    },
    avenge_digital_ping_post: {
        fields: {
            output_tag_prefix: 'avenge_digital_12345',

            ping_url: 'https://www.avengehub.com/Api/PingV1?apiKey=TEMPLATE_API_KEY',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"CampaignId":TEMPLATE_CAMPAIGN_ID,"ZipCode":"[caller_zip]","CallerPhoneNumber":"[nanp_caller_number]","ExternalId":"[call_uuid]","CustomerData":{"FirstName":"Unavailable","LastName":"Unavailable","Address":"Unavailable","City":"[caller_city]","ZipCode":"[caller_zip]","State":"[caller_state]","Email":"Unavailable","Birthdate":"1955-12-30","ContactPhoneNumber":"[nanp_caller_number]","LifeInsurance":{}}}',
            ping_output_map: '{"PingOutputMap":{"ping_id":"Id","number":"PhoneNumber","bid":"Payout.Amount","timer":"Payout.QualifiedDurationInSeconds"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://www.avengehub.com/Api/PostV1?apiKey=TEMPLATE_API_KEY',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"Id":"<podd_start>ping_id<podd_end>","CampaignId":TEMPLATE_CAMPAIGN_ID,"ZipCode":"[caller_zip]","CallerPhoneNumber":"[nanp_caller_number]","ExternalId":"[call_uuid]","CustomerData":{"FirstName":"Unavailable","LastName":"Unavailable","Address":"Unavailable","City":"[caller_city]","ZipCode":"[caller_zip]","State":"[caller_state]","Email":"Unavailable","Birthdate":"1955-12-30","ContactPhoneNumber":"[nanp_caller_number]","LifeInsurance":{}}}',
            post_output_map: '{"PostOutputMap":{"accepted":"IsAccepted"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag the buyer with a boolean tag value of 'OUTPUT_TAG_PREFIX_accepted = true'.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Avenge Digital API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Avenge Digital request returns a valid transfer number, Retreaver will open the Avenge Digital integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Avenge Digital integrated buyer.\n\n2) Update the 'TEMPLATE_API_KEY' on both the 'Ping URL' and 'Post URL' fields, and then update the 'TEMPLATE_CAMPAIGN_ID' values in the 'Ping Data' and 'Post Data' fields with the values provided by Avenge Digital.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Avenge Digital API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "campaign_id",
                property_name: "Avenge Digital Campaign ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ]
    },
    blacklist_alliance: {
        fields: {
            output_tag_prefix: 'blacklist_alliance',

            ping_url: 'https://api.blacklistalliance.net/standard/api/v1/Lookup/key/TEMPLATE_API_KEY/response/json/phone/[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"message":"message"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_message' as the key, \n'equals' as the operator, \n'Good' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Blacklist Alliance API to request a boolean 'message' response value representing the eligibility of the caller. If the 'message' response value is 'Good', Retreaver will open the Blacklist Alliance integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping URL' field to match with the instructions provided by Blacklist Alliance, replace the 'TEMPLATE_API_KEY' in the URL.\n\n2) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "api_key",
                property_name: "Blacklist Alliance API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ]
    },
    dig_thrive_ping: {
        fields: {
            output_tag_prefix: 'digthrive_12345',

            ping_url: 'https://in.digthrive.com/dig/feeddata/add?uid=TEMPLATE_UID&phone1=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"bid":"price","timer":"duration","number":"phoneNumber"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the DigThrive API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the DigThrive request returns a valid transfer number, Retreaver will open the DigThrive integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the DigThrive integrated buyer.\n\n2) Update the 'TEMPLATE_UID' on the 'Ping URL' field with the value provided by DigThrive.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_UID",
                property_name: "DigThrive API UID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_UID"
            }
        ]
    },
    go_high_level_data_post: {
        fields: {
            output_tag_prefix: 'gohighlevel_12345',

            ping_url: 'https://rest.gohighlevel.com/v1/contacts/',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Bearer TEMPLATE_BEARER_TOKEN"}',
            ping_data: '{"firstName":"[TEMPLATE_FIRST_NAME]","lastName":"[TEMPLATE_LAST_NAME]","phone":"[nanp_caller_number]","dateOfBirth":"[TEMPLATE_DOB]","city":"[caller_city]","state":"[caller_state]","postalCode":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"contact_id":"contact.id"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected.\n\n3) Update your campaign to apply your webhook changes."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to GoHighLevel's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the GoHighLevel integrated buyer.\n\n2) Update the 'Ping Header' 'TEMPLATE_BEARER_TOKEN' field using the instructions provided by GoHighLevel.\n\n3) Update the 'Ping Data' fields to include any required values you wish to pass. Make sure you update any fields with a 'TEMPLATE' prefix to match with the tag key you are storing the caller details under.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "bearer_token",
                property_name: "Go High Level Bearer Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_BEARER_TOKEN"
            },
            {
                property_id: "first_name",
                property_name: "Caller First Name Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_FIRST_NAME]"
            },
            {
                property_id: "last_name",
                property_name: "Caller Last Name Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_LAST_NAME]"
            },
            {
                property_id: "dob",
                property_name: "Caller Date Of Birth Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_DOB]"
            },
        ]
    },
    health_markets_ping_post: {
        fields: {
            output_tag_prefix: 'health_markets_12345',

            ping_url: 'https://lc-api.healthmarkets.com/api/caller/lead/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization-Token":"TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"CallerId":"[nanp_caller_number]","VendorCode":"TEMPLATE_VENDORCODE","CampaignCode":"TEMPLATE_CAMPAIGNCODE","State":"[caller_state]","Zip":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"pingid":"PingId","bid":"Bid"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://lc-api.healthmarkets.com/api/caller/lead/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","Authorization-Token":"TEMPLATE_AUTHORIZATION_TOKEN"}',
            post_data: '{"VendorCode":"TEMPLATE_VENDORCODE","CampaignCode":"TEMPLATE_CAMPAIGNCODE","PingId":"<podd_start>pingid<podd_end>","PrimaryPhone":"[nanp_caller_number]","Address":{"State":"[caller_state]","Zip":"[caller_zip]"}}',
            post_output_map: '{"PostOutputMap":{"PostId":"PostId","LeadId":"LeadId","HasError":"HasError"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) Tag the buyer with a numerical tag value of 'OUTPUT_TAG_PREFIX_bid 'is greater than' '0', this will prevent routing to the buyer if no bid was returned.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Health Markets API to request for a potential conversion bid. If the Health Markets request returns a valid bid, Retreaver will open the Health Markets integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Health Markets integrated buyer.\n\n2) Update the 'TEMPLATE_AUTHORIZATION_TOKEN' on both the 'Ping Headers' and 'Post Header' fields.\n\n3) Update the 'TEMPLATE_VENDORCODE' and 'TEMPLATE_CAMPAIGNCODE' values in the 'Ping Data' and 'Post Data' fields with the values provided by Health Markets.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "authorization_token",
                property_name: "Health Markets Authorization Token",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            },
            {
                property_id: "vendor_code",
                property_name: "Health Markets Vendor Code",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_VENDORCODE"
            },
            {
                property_id: "campaign_code",
                property_name: "Health Markets Campaign Code",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGNCODE"
            }
        ]
    },
    national_debt_relief_data_post: {
        fields: {
            output_tag_prefix: 'national_debt_relief_12345',

            ping_url: 'https://apply.nationaldebtrelief.com/services/apexrest/affiliates/TEMPLATE_AFFILIATE_CODE/lead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"firstname":"[TEMPLATE_FIRSTNAME]","lastname":"[TEMPLATE_LASTNAME]","email":"[TEMPLATE_EMAIL]","phone":"[nanp_caller_number]","address1":"[TEMPLATE_ADDRESS]","city":"[caller_city]","state":"[caller_state]","zipcode":"[caller_zip]","totaldebtamount":"[TEMPLATE_DEBT_AMOUNT]"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected.\n\n3) Update your campaign to apply your webhook changes."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to National Debt Relief's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the National Debt Relief integrated buyer.\n\n2) Update the 'Ping Url' 'TEMPLATE_AFFILIATE_CODE' field using the instructions provided by National Debt Relief.\n\n3) Update the 'Ping Data' fields to include any required values you wish to pass. Make sure to update any replacement token fields containing the 'TEMPLATE' placeholder with the Retreaver tag key you are using to store those values.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "NDR API Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://apply.nationaldebtrelief.com/services/apexrest/affiliates/TEMPLATE_AFFILIATE_CODE/lead"
            },
            {
                property_id: "first_name",
                property_name: "Caller First Name Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_FIRSTNAME]"
            },
            {
                property_id: "last_name",
                property_name: "Caller Last Name Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_LASTNAME]"
            },
            {
                property_id: "email",
                property_name: "Caller Email Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_EMAIL]"
            },
            {
                property_id: "address",
                property_name: "Caller Address Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_ADDRESS]"
            },
            {
                property_id: "debt_amount",
                property_name: "Caller Debt Amount Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_DEBT_AMOUNT]"
            },
        ]
    },
    phonexa_ping: {
        fields: {
            output_tag_prefix: 'phonexa_12345',

            ping_url: 'https://TEMPLATE_URL_PREFIX.phonexa.com/lead/?apiID=TEMPLATE_ID&apiPassword=TEMPLATE_PASSWORD&productId=TEMPLATE_PRODUCT_ID&price=0&firstName=[TEMPLATE_FN]&lastName=[TEMPLATE_LN]&email=[TEMPLATE_EMAIL]&zip=[caller_zip]&dob=[TEMPLATE_DOB]&state=[caller_state]&phoneNumber=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"bid":"price","status_text":"status_text"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) For the buyer tag list, apply the following numeric tag filter: 'OUTPUT_TAG_PREFIX_bid' 'greater than' '0', this will open the buyer for routing only when a bid is received.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Phonexa API to request for a potential conversion bid. If the Phonexa request returns a valid bid, Retreaver will open the Phonexa integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Phonexa integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Phonexa, start by updating the following fields: 'TEMPLATE_ID', 'TEMPLATE_PASSWORD', 'TEMPLATE_PRODUCT_ID'.\n\n3) Update the remaining fields in the 'Ping URL' prefixed with 'TEMPLATE' with the replacement tag key tokens you are using to store those values, including 'TEMPLATE_FN', 'TEMPLATE_LN', 'TEMPLATE_EMAIL' and 'TEMPLATE_DOB'.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Phonexa API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL_PREFIX.phonexa.com/lead/"
            },
            {
                property_id: "api_id",
                property_name: "Phonexa API ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ID"
            },
            {
                property_id: "api_password",
                property_name: "Phonexa API Password",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PASSWORD"
            },
            {
                property_id: "product_id",
                property_name: "Phonexa Product ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PRODUCT_ID"
            },
            {
                property_id: "first_name",
                property_name: "Caller First Name Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "[TEMPLATE_FN]"
            },
            {
                property_id: "last_name",
                property_name: "Caller Last Name Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "[TEMPLATE_LN]"
            },
            {
                property_id: "email",
                property_name: "Caller Email Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "[TEMPLATE_EMAIL]"
            },
            {
                property_id: "dob",
                property_name: "Caller Date Of Birth Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "[TEMPLATE_DOB]"
            }
        ]
    },
    visiqua_ping: {
        fields: {
            output_tag_prefix: 'visiqua_12345',

            ping_url: 'https://api.callstoconvert.com/api/callAPI',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"campaign_token":"TEMPLATE_CAMPAIGN_TOKEN","caller_id":"[nanp_caller_number]","zip_code":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"bid":"payout","timer":"duration","number":"DID"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Visiqua API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Visiqua request returns a valid transfer number, Retreaver will open the Visiqua integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Visiqua integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_CAMPAIGN_TOKEN' field to match with the instructions provided by Visiqua.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_token",
                property_name: "Visiqua Campaign Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_TOKEN"
            }
        ]
    },
    quote_wizard_health_ping: {
        fields: {
            output_tag_prefix: 'quotewizard_12345',

            ping_url: 'https://api.quotewizard.com/calls/v1/InboundPingPartialLead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"campaignId":TEMPLATE_CAMPAIGN_ID,"Apikey":"TEMPLATE_API_KEY","data":{"quoteRequest":{"item":{"contact":{"zipCode":"[caller_zip]"},"healthInsuranceQuoteRequest":{"person":{"birthDate":"[TEMPLATE_DOB-YYYY-MM-DD-FORMAT]"}}}}}}',
            ping_output_map: '{"PingOutputMap":{"number":"phoneNumber","bid":"bid","timer":"payableThreshold"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the QuoteWizard Health API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the QuoteWizard request returns a valid transfer number, Retreaver will open the QuoteWizard integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the QuoteWizard integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_CAMPAIGN_ID' and 'TEMPLATE_API_KEY' fields to match with the instructions provided by QuoteWizard.\n\n3) For the Caller DOB value, provide a hardcoded DOB or use a tag replacement token if you are collecting that value.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_id",
                property_name: "QuoteWizard Campaign ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "api_key",
                property_name: "QuoteWizard API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "dob",
                property_name: "Caller Date Of Birth Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_DOB-YYYY-MM-DD-FORMAT]"
            }
        ]
    },
    quote_wizard_auto_ping: {
        fields: {
            output_tag_prefix: 'quotewizard_12345',

            ping_url: 'https://api.quotewizard.com/calls/v1/InboundPingPartialLead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"campaignId":TEMPLATE_CAMPAIGN_ID,"Apikey":"TEMPLATE_API_KEY","data":{"quoteRequest":{"item":{"contact":{"zipCode":"[caller_zip]"},"autoInsuranceQuoteRequest":{"insuranceProfile":{"currentPolicy":{"insuranceCompany":{"CompanyName":"UNKNOWN"}}}}}}}}',
            ping_output_map: '{"PingOutputMap":{"number":"phoneNumber","bid":"bid","timer":"payableThreshold"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the QuoteWizard Auto API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the QuoteWizard request returns a valid transfer number, Retreaver will open the QuoteWizard integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the QuoteWizard integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_CAMPAIGN_ID' and 'TEMPLATE_API_KEY' fields to match with the instructions provided by QuoteWizard.\n\n3) For the Insurance Company Name value, enter 'UNKNOWN' for uninsured, or OTHER if insured.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_id",
                property_name: "QuoteWizard Campaign ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "api_key",
                property_name: "QuoteWizard API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "insurance_company",
                property_name: "Caller Insurance Company Name",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "UNKNOWN"
            }
        ]
    },
    wisdom_co_ping: {
        fields: {
            output_tag_prefix: 'wisdomco_12345',

            ping_url: 'https://api-gw.thewisdomco.com/retreaver/publishers/pre-ping?publisherUuid=TEMPLATE_PUBLISHER_UUID&publisherSlug=TEMPLATE_PUBLISHER_SLUG&publisherPostbackKey=TEMPLATE_PUBLISHER_POSTBACK_KEY&campaignSlug=TEMPLATE_CAMPAIGN_SLUG&callerId=[nanp_caller_number]&publisherPhone=[called_number]&zipCode=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"bid":"bid.amount","timer":"bid.duration","allowed":"allowed"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Scroll to the 'Tag List' section, then press the 'wizard' button.\n\n6) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_bid' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n7) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_allowed' as the key, \n'equals' as the operator, \n'true' as the value.\n\n8) Press 'add' on the tag wizard then press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the WisdomCo API to request for a potential conversion bid and conversion timer. If the WisdomCo request returns a valid bid, Retreaver will open the WisdomCo integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the WisdomCo integrated buyer.\n\n2) Update the 'Ping Url' 'TEMPLATE_PUBLISHER_UUID', 'TEMPLATE_PUBLISHER_SLUG', 'TEMPLATE_PUBLISHER_POSTBACK_KEY' and 'TEMPLATE_CAMPAIGN_SLUG' fields to match with the instructions provided by WisdomCo.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "publisher_uuid",
                property_name: "WisdomCo Publisher UUID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_UUID"
            },
            {
                property_id: "publisher_slug",
                property_name: "WisdomCo Publisher Slug",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_SLUG"
            },
            {
                property_id: "publisher_postback_key",
                property_name: "WisdomCo Publisher Postback Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_POSTBACK_KEY"
            },
            {
                property_id: "campaign_slug",
                property_name: "WisdomCo Campaign Slug",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_SLUG"
            }
        ]
    },
    americas_health_center_availability: {
        fields: {
            output_tag_prefix: 'ahc_12345',

            ping_url: 'https://manage.americashealthcenter.org/api/AgentStatus?ApiKey=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"agents_waiting":"agents_waiting"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_agents_waiting' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Americas Health Center Agent Availability API to request a numeric 'agents_waiting' response value representing the number of agents available to take a call. If the 'agents_waiting' response value is above 0, Retreaver will open the Americas Health Center integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Americas Health Center integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Americas Health Center, including the TEMPLATE_API_KEY parameter.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Americas Health Center API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ]
    },
    call_tools_availability: {
        fields: {
            output_tag_prefix: 'call_tools_12345',

            ping_url: 'https://east-1.calltools.io/api/agentstatuses/?queue=TEMPLATE_QUEUE_VALUE',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded","Authorization":"Token TEMPLATE_TOKEN"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"count":"count"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_count' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Call Tools Agent Availability API to request a numeric 'count' response value representing the number of agents ready to take a call. If the 'count' response value is above 0, Retreaver will open the Call Tools integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Call Tools integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Call Tools, including the TEMPLATE_QUEUE_VALUE parameter.\n\n3) Update the 'Ping Header' field to match with the instructions provided by Call Tools, including the TEMPLATE_TOKEN authorization token.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "queue",
                property_name: "CallTools Queue Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_QUEUE_VALUE"
            },
            {
                property_id: "authorization_token",
                property_name: "CallTools Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_TOKEN"
            }
        ]
    },
    free_voice_availability: {
        fields: {
            output_tag_prefix: 'free_voice_12345',

            ping_url: 'https://TEMPLATE_URL.freevoicepbx.com/api/agentsavailapi/?api_key=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"available":"data.available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Free Voice Agent Availability API to request a numeric 'available' response value representing the number of agents ready to take a call. If the 'available' response value is above 0, Retreaver will open the Free Voice integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Free Voice integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Free Voice, including the TEMPLATE_API_KEY parameter.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "FreeVoice API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.freevoicepbx.com/api/agentsavailapi/"
            },
            {
                property_id: "api_key",
                property_name: "FreeVoice API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ]
    },
    retreaver_rtb_ping: {
        fields: {
            output_tag_prefix: 'retreaver_rtb_12345',

            ping_url: 'https://rtb.retreaver.com/rtbs.json?caller_number=[nanp_caller_number]&key=TEMPLATE_RTB_KEY&publisher_id=TEMPLATE_PUBLISHER_ID',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"number":"inbound_number","bid":"retreaver_payout","timer":"retreaver_seconds"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Retreaver RTB API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Retreaver RTB request returns a valid transfer number, Retreaver will open the Retreaver RTB integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Retreaver RTB integrated buyer.\n\n2) Update the 'Ping URL' 'TEMPLATE_RTB_KEY' and 'TEMPLATE_PUBLISHER_ID' fields to match with the instructions provided by the Retreaver RTB provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "rtb_key",
                property_name: "Retreaver RTB Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_RTB_KEY"
            },
            {
                property_id: "publisher_id",
                property_name: "Retreaver Publisher ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_ID"
            }
        ]
    },
    d2m_ping_post: {
        fields: {
            output_tag_prefix: 'd2m_12345',

            ping_url: 'ttps://offers.d2m-api.com/v1/offers/search?FsearchType=broad&category=TEMPLATE_CATEGORY&subCategory=TEMPLATE_SUBCATEGORY&keyword=&brandName=&channel=&radius=&city=[caller_city]&state=[caller_state]&limit=10',
            ping_method: 'GET',
            ping_headers: '{"Content-Type": "application/x-www-form-urlencoded","x-api-key":"TEMPLATE_API_KEY"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"id":"0.id","timer":"0.billableDuration","bid":"0.advertiserPayout"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://offers.d2m-api.com/v1/offers/callback?request_id=<podd_start>id<podd_end>',
            post_method: 'POST',
            post_headers: '{"Content-Type": "application/x-www-form-urlencoded","x-api-key":"TEMPLATE_API_KEY"}',
            post_data: '{}',
            post_output_map: '{"PostOutputMap":{"number":"number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the D2M API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the D2M request returns a valid transfer number, Retreaver will open the D2M integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the D2M integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by D2M, update the 'TEMPLATE_CATEGORY' and then update the 'TEMPLATE_SUBCATEGORY' url parameters with the values provided by D2M.\n\n3) Update the ping and post header fields to match with the instructions provided by D2M, update the 'TEMPLATE_API_KEY' with the value provided by D2M.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "category",
                property_name: "D2M Category",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CATEGORY"
            },
            {
                property_id: "subcategory",
                property_name: "D2M Subcategory",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SUBCATEGORY"
            },
            {
                property_id: "api_key",
                property_name: "D2M X-API-Key",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ]
    },
    elocal_ping: {
        fields: {
            output_tag_prefix: 'elocal_12345',

            ping_url: 'http://api.elocal.com/call/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"ping": {"zip_code":"[caller_zip]", "need_id": "TEMPLATE_NEED_ID", "key":"TEMPLATE_KEY"}}',
            ping_output_map: '{"PingOutputMap":{"status":"response.status","number":"response.phone_number","bid":"response.price","timer":"response.billable_duration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the ELocal API to request for a potential conversion bid and dynamic transfer number. If the ELocal request returns a valid transfer number, Retreaver will open the ELocal integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the ELocal integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_NEED_ID' and 'TEMPLATE_KEY' fields to match with the instructions provided by the ELocal provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "need_id",
                property_name: "ELocal Need ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_NEED_ID"
            },
            {
                property_id: "key",
                property_name: "ELocal API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_KEY"
            }
        ]
    },
    easy_health_ping: {
        fields: {
            output_tag_prefix: 'easy_health_12345',

            ping_url: 'https://availability.easyhealth.dev/api/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"accessToken":"TEMPLATE_ACCESS_TOKEN","phone":"[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{"bid":"bid","timer":"billableDuration","number":"did","bidid":"bidid"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Easy Health API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Easy Health request returns a valid transfer number, Retreaver will open the Easy Health integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Easy Health integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_ACCESS_TOKEN' field to match with the instructions provided by the Easy Health provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "access_token",
                property_name: "EasyHealth Access Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_ACCESS_TOKEN"
            }
        ]
    },
    archenia_ping: {
        fields: {
            output_tag_prefix: 'archenia_12345',

            ping_url: 'https://services.archenia.io/mcm/listings?partnerId=TEMPLATE_PARTNER_ID&searchType=TEMPLATE_SEARCH_TYPE&searchTerm=TEMPLATE_SEARCH_TERM&city=[caller_city]&state=[caller_state]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"number":"0.callTrackingNumber","timer":"0.billableDuration","bid":"0.publisherPayout","business_name":"0.businessName"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Archenia API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Archenia request returns a valid transfer number, Retreaver will open the Archenia integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Archenia integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_PARTNER_ID', 'TEMPLATE_SEARCH_TYPE', 'TEMPLATE_SEARCH_TERM' to match with the instructions provided by the Archenia provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "partner_id",
                property_name: "Archenia Partner ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PARTNER_ID"
            },
            {
                property_id: "search_type",
                property_name: "Archenia Search Type",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SEARCH_TYPE"
            },
            {
                property_id: "search_term",
                property_name: "Archenia Search Term",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SEARCH_TERM"
            }
        ]
    },
    marchex_ping: {
        fields: {
            output_tag_prefix: 'marchex_12345',

            ping_url: 'https://services.marchex.com/mcm/listings?partnerId=TEMPLATE_PARTNER_ID&searchType=TEMPLATE_SEARCH_TYPE&searchTerm=TEMPLATE_SEARCH_TERM&radius=50&zip=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"number":"Response[0].callTrackingNumber","business_name":"Response[0].businessName","timer":"Response[0].billableDuration","bid":"Response[0].publisherPayout"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Marchex API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Marchex request returns a valid transfer number, Retreaver will open the Marchex integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Marchex integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_PARTNER_ID', 'TEMPLATE_SEARCH_TYPE', 'TEMPLATE_SEARCH_TERM' to match with the instructions provided by the Marchex provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "partner_id",
                property_name: "Marchex Partner ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PARTNER_ID"
            },
            {
                property_id: "search_type",
                property_name: "Marchex Search Type",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SEARCH_TYPE"
            },
            {
                property_id: "search_term",
                property_name: "Marchex Search Term",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SEARCH_TERM"
            }
        ]
    },
    soleo_ping: {
        fields: {
            output_tag_prefix: 'soleo_12345',

            ping_url: 'https://api.soleo.com/sponsored?Category=TEMPLATE_CATEGORY&City=[caller_city]&State=[caller_state]&APIKey=TEMPLATE_API_KEY&MaxSponsoredCount=1&ANI=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded","Accept":"application/vnd.api.soleo.com-v2%2Bjson"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"number":"businesses[0].completionPhoneNumber","timer":"businesses[0].monetizationCritera.criteria","bid":"businesses[0].monetizationCritera.value"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Soleo API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Soleo request returns a valid transfer number, Retreaver will open the Soleo integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Soleo integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_CATEGORY', 'TEMPLATE_API_KEY' to match with the instructions provided by the Soleo provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "category",
                property_name: "Soleo Category",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CATEGORY"
            },
            {
                property_id: "api_key",
                property_name: "Soleo API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ]
    },
    all_calls_availability: {
        fields: {
            output_tag_prefix: 'allcalls_12345',

            ping_url: 'https://allcalls.io/api/agent-status?phone=[nanp_caller_number]&vertical=TEMPLATE_VERTICAL&affiliate_id=TEMPLATE_AFFILIATE_ID&api_key=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"online":"online"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_online' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the All Calls Agent Availability API to request a boolean 'online' response value representing if an agent is available to take a call. If the 'online' response equals 'true', Retreaver will open the All Calls integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the All Calls integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_VERTICAL', 'TEMPLATE_AFFILIATE_ID', 'TEMPLATE_API_KEY' to match with the instructions provided by All Calls.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "vertical",
                property_name: "AllCalls Vertical",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_VERTICAL"
            },
            {
                property_id: "affiliate_id",
                property_name: "AllCalls Affiliate ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_AFFILIATE_ID"
            },
            {
                property_id: "api_key",
                property_name: "AllCalls API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ]
    },
    benefit_align_availability: {
        fields: {
            output_tag_prefix: 'benefit_align_12345',

            ping_url: 'https://mme.benefitalign.com/v2/cti/external/TEMPLATE_PARTNER_CODE/agentavailability',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"eventContext":{"contextMap":{"entries":[{"key":"campaignGroupNumber","value":"TEMPLATE_CAMPAIGN_GROUP_NUMBER"},{"key":"leadVendorName","value":"TEMPLATE_VENDOR_NAME"}]}}}',
            ping_output_map: '{"PingOutputMap":{"availability_value":"contextMap.entries[0].value"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_availability_value' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Benefit Align Agent Availability API to request a boolean 'availability_value' response value representing if an agent is available to take a call. If the 'availability_value' response equals 'true', Retreaver will open the Benefit Align integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Benefit Align integrated buyer.\n\n2) Update the following 'Ping URL' parameter: 'TEMPLATE_PARTNER_CODE', then update the following 'Ping Header' parameter: 'TEMPLATE_X_API_KEY', lastly update the following 'Ping Data' parameter: 'TEMPLATE_CAMPAIGN_GROUP_NUMBER' and 'TEMPLATE_VENDOR_NAME' to match with the instructions provided by Benefit Align.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "BenefitAlign API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://mme.benefitalign.com/v2/cti/external/TEMPLATE_PARTNER_CODE/agentavailability"
            },
            {
                property_id: "x_api_key",
                property_name: "BenefitAlign X-API-KEY",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "campaign_group_number",
                property_name: "BenefitAlign Campaign Group Number",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_GROUP_NUMBER"
            },
            {
                property_id: "vendor_name",
                property_name: "BenefitAlign Vendor Name",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_VENDOR_NAME"
            },
        ]
    },
    hive_hq_availability: {
        fields: {
            output_tag_prefix: 'hivehq_availability_12345',

            ping_url: 'https://buyers.ps-api.hivehq.co/v1/availability',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"key":"TEMPLATE_KEY","phone":"[nanp_caller_number]","zip":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"message":"message","reservation_number":"data.reservation_number"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Hive HQ Agent Availability API to request a dynamic 'reservation_number' representing if an agent is available to take a call. If the 'reservation_number' response is present, Retreaver will route the call using the 'reservation_number' for the Hive HQ integrated buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Hive HQ integrated buyer.\n\n2) Update the following 'Ping Data' parameter: 'TEMPLATE_KEY' to match with the instructions provided by Hive HQ.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "HiveHQ API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_KEY"
            }
        ]
    },
    winning_availability: {
        fields: {
            output_tag_prefix: 'winning_12345',

            ping_url: 'https://www.winning.today/posting/template-availability-ping',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"available_agents":"template_available_agents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'is_greater_than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Winning Agent Availability API to request a numeric 'available_agents' response value representing if an agent is available to take a call. If the 'available_agents' response is greater than '0', Retreaver will open the Winning integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Winning integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Winning.\n\n3) Replace the 'template_available_agents' response key in the 'Ping Output Map' field, which represents the JSON key we expect to access the agent availability value from the response of the API.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Winning URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://www.winning.today/posting/template-availability-ping"
            },
            {
                property_id: "response_key",
                property_name: "Winning Response Key",
                fields_to_replace: [
                    "ping_output_map"
                ],
                replacement_token: "template_available_agents"
            }
        ]
    },
    chasedata_availability: {
        fields: {
            output_tag_prefix: 'chasedata_12345',

            ping_url: 'https://api.chasedatacorp.com/HttpImport/CallOperations.php?token=TEMPLATE_TOKEN&accid=TEMPLATE_ACCID&Action=AvailableInboundAgents&DID=TEMPLATE_DID',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"available_agents":"AvailableInboundAgents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'is greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the ChaseData Agent Availability API to request a numeric 'available_agents' response value representing if an agent is available to take a call. If the 'available_agents' response is greater than '0', Retreaver will open the ChaseData integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the ChaseData integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by ChaseData, update the 'TEMPLATE_TOKEN', 'TEMPLATE_ACCID' and 'TEMPLATE_DID' url parameters.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "token",
                property_name: "ChaseData Token",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_TOKEN"
            },
            {
                property_id: "accid",
                property_name: "ChaseData Accid",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ACCID"
            },
            {
                property_id: "did",
                property_name: "ChaseData DID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_DID"
            }
        ]
    },
    leadspedia_ping: {
        fields: {
            output_tag_prefix: 'leadspedia_12345',

            ping_url: 'https://TEMPLATE_URL.leadspediatrack.com/call-preping.do?lp_campaign_id=TEMPLATE_CAMPAIGN_ID&lp_campaign_key=TEMPLATE_CAMPAIGN_KEY&caller_id=[nanp_caller_number]&zip_code=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"number":"number","timer":"duration","bid":"payout","result":"result","status":"status"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Leadspedia API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Leadspedia request returns a valid transfer number, Retreaver will open the Leadspedia integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Leadspedia integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_CAMPAIGN_ID', 'TEMPLATE_CAMPAIGN_KEY' to match with the instructions provided by the Leadspedia provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "leadspedia_ping_url",
                property_name: "Leadspedia Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.leadspediatrack.com/call-preping.do"
            },
            {
                property_id: "lp_campaign_id",
                property_name: "Leadspedia Campaign ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "lp_campaign_key",
                property_name: "Leadspedia Campaign Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_KEY"
            }
        ]
    },
    marketcall_ping: {
        fields: {
            output_tag_prefix: 'marketcall_12345',

            ping_url: 'https://www.marketcall.com/api/v1/affiliate/offers/9999/bid-requests',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"campaign_id": "TEMPLATE_CAMPAIGN_ID","caller_id": "1[nanp_caller_number]","zip_code":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"number":"data.target_number","timer":"data.terms.duration[0].value","bid":"data.earn.amount"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the MarketCall API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the MarketCall request returns a valid transfer number, Retreaver will open the MarketCall integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the MarketCall integrated buyer.\n\n2) Update the 'Ping URL' field, the 'TEMPLATE_X_API_KEY' in the 'Ping Headers' field and the 'TEMPLATE_CAMPAIGN_ID' in the 'Ping Data' field to match with the instructions provided by the MarketCall provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "MarketCall URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://www.marketcall.com/api/v1/affiliate/offers/9999/bid-requests"
            },
            {
                property_id: "api_key",
                property_name: "MarketCall X-API-Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "campaign_id",
                property_name: "MarketCall Campaign ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ]
    },
    everquote_ping: {
        fields: {
            output_tag_prefix: 'everquote_12345',

            ping_url: 'https://calls.everquote.com/ivr_integration/auto',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Basic%20TEMPLATE_TOKEN"}',
            ping_data: '{"phone_number": "[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{"timer":"duration_seconds","bid_cents":"bid_cents","bid":"bid_cents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: 'bid',
            revshare_modifier_percentage: '0.01'
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) This integration does not return a dynamic transfer number, ensure your buyer profile has a defined transfer number present.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Everquote API to request for a potential conversion bid and conversion timer. If the Everquote request returns a valid bid, Retreaver will open the Everquote integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Everquote integrated buyer.\n\n2) Update the 'Ping URL' field, and the 'TEMPLATE_TOKEN' in the 'Ping Headers' field to match with the instructions provided by the Everquote provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Everquote URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://calls.everquote.com/ivr_integration/auto"
            },
            {
                property_id: "authorization_token",
                property_name: "Everquote Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_TOKEN"
            }
        ]
    },
    pipedream_ping: {
        fields: {
            output_tag_prefix: 'pipedream_12345',

            ping_url: 'https://template.m.pipedream.net/?pub=TEMPLATE_PUB&phone_number=[nanp_caller_number]&state=[caller_state]&sub1=&sub2=&pub_id=',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"available_inbound_agents":"AvailableInboundAgents","bid":"bid","timer":"duration","number":"did"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Pipedream API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Pipedream request returns a valid transfer number, Retreaver will open the Pipedream integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Pipedream integrated buyer.\n\n2) Update the 'Ping URL' field, and the 'TEMPLATE_PUB' in the 'Ping URL' field to match with the instructions provided by the Pipedream provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Pipedream URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://template.m.pipedream.net/"
            },
            {
                property_id: "pub_id",
                property_name: "Pipedream Publisher Parameter",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUB"
            }
        ]
    },
    home_appointments_ping_post: {
        fields: {
            output_tag_prefix: 'home_appointments_12345',

            ping_url: 'https://homeappointments.leadportal.com/new_api/api.php?Mode=ping&Format=JSON&Key=TEMPLATE_KEY&API_Action=iprSubmitLead&TYPE=9&SRC=TEMPLATE_SOURCE&ZIP=[caller_zip]&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Trade=TEMPLATE_TRADE&Origin_Phone=[nanp_caller_number]&Return_Best_Price=1&Return_Min_Duration=1',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"bid":"response.price","timer":"response.min_duration","lead_id":"response.lead_id"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'exists',
            post_condition_value: '0',

            post_url: 'https://homeappointments.leadportal.com/new_api/api.php?Mode=post&Format=JSON&Key=TEMPLATE_KEY&API_Action=iprSubmitLead&TYPE=9&SRC=TEMPLATE_SOURCE&ZIP=[caller_zip]&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Trade=TEMPLATE_TRADE&Origin_Phone=[nanp_caller_number]&Return_Best_Price=1&Return_Min_Duration=1&Lead_ID=<podd_start>lead_id<podd_end>',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{}',
            post_output_map: '{"PostOutputMap":{"post_status":"response.status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and ensure the 'Number' matches the terminating phone value: 'TEMPLATE_TERMINATING_PHONE'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag your buyer with 'OUTPUT_TAG_PREFIX_post_success:Success' to ensure the buyer is only routed when the post request is accepted.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Home Appointments API to request for a potential conversion bid and conversion timer. If the Home Appointments request returns a valid bid, Retreaver will open the Home Appointments integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Home Appointments integrated buyer.\n\n2) Update the 'Ping URL' and 'Post URL' including: TEMPLATE_KEY, TEMPLATE_SOURCE, TEMPLATE_TERMINATING_PHONE & TEMPLATE_TRADE fields with the values provided by Home Appointments.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Home Appointments Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            },
            {
                property_id: "source",
                property_name: "Home Appointments Source",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            },
            {
                property_id: "terminating_phone",
                property_name: "Home Appointments Terminating Phone",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TERMINATING_PHONE"
            },
            {
                property_id: "trade",
                property_name: "Home Appointments Trade",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TRADE"
            }
        ]
    },
    service_direct_ping_post: {
        fields: {
            output_tag_prefix: 'service_direct_12345',

            ping_url: 'https://api.servicedirect.com/partners/request',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"zip_code": "[caller_zip]","service_category": TEMPLATE_SERVICE_CATEGORY,"sd_api_key":"TEMPLATE_SD_API_KEY"}',
            ping_output_map: '{"PingOutputMap":{"available_buyer":"data.available_buyer","request_id":"data.request_id","timer":"data.min_duration","bid":"data.bid"}}',

            post_condition_key: 'available_buyer',
            post_condition_operator: 'is_equal',
            post_condition_value: 'true',

            post_url: 'https://api.servicedirect.com/partners/request/<podd_start>request_id<podd_end>/accept',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"sd_api_key":"TEMPLATE_SD_API_KEY"}',
            post_output_map: '{"PostOutputMap":{"number":"data.phone_number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Service Direct API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Service Direct request returns a valid transfer number, Retreaver will open the Service Direct integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Service Direct integrated buyer.\n\n2) Update the 'Ping Data' TEMPLATE_SERVICE_CATEGORY & TEMPLATE_SD_API_KEY fields and the 'Post Data' TEMPLATE_SD_API_KEY field to match with the instructions provided by Service Direct.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "service_category",
                property_name: "Service Direct Service Category",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SERVICE_CATEGORY"
            },
            {
                property_id: "sd_api_key",
                property_name: "Service Direct SD API Key",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SD_API_KEY"
            }
        ]
    },
    accidentdotcom_availability: {
        fields: {
            output_tag_prefix: 'accident_dot_com_preping_12345',

            ping_url: 'https://api.accident.com/api/lead-ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","api-key":"TEMPLATE_API_KEY","api-secret":"TEMPLATE_API_SECRET"}',
            ping_data: '{ "lead_email": "[email]", "lead_phone": "+1[nanp_caller_number]" }',
            ping_output_map: '{"PingOutputMap":{"duplicate":"response.duplicate"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_duplicate' as the key, \n'equals' as the operator, \n'false' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Accident.com Availability API to request a boolean 'duplicate' response value representing if the lead is unique. If the 'duplicate' response equals 'false', Retreaver will open the Enhance integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Accident.com integrated buyer.\n\n2) Update the 'Ping Headers' field to match with the instructions provided by Accident.com.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Accident.com API Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "api_secret",
                property_name: "Accident.com API Secret",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_API_SECRET"
            }
        ]
    },
    leadportal_ping_post: {
        fields: {
            output_tag_prefix: 'leadportal_12345',

            ping_url: 'https://TEMPLATE_URL.leadportal.com/new_api/api.php?Mode=ping&Format=JSON&Key=TEMPLATE_KEY&API_Action=TEMPLATE_ACTION&TYPE=TEMPLATE_TYPE&SRC=TEMPLATE_SOURCE&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Return_Best_Price=1',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"bid":"response.price","timer":"response.min_duration","lead_id":"response.lead_id"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://TEMPLATE_URL.leadportal.com/new_api/api.php?Mode=post&Format=JSON&Key=TEMPLATE_KEY&API_Action=TEMPLATE_ACTION&TYPE=TEMPLATE_TYPE&SRC=TEMPLATE_SOURCE&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Lead_ID=<podd_start>lead_id<podd_end>&Return_Best_Price=1&Origin_Phone_Country_Code=1&Origin_Phone=[nanp_caller_number]',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '{}',
            post_output_map: '{"PostOutputMap":{"post_status":"response.status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and ensure the 'Number' matches the terminating phone value: 'TEMPLATE_TERMINATING_PHONE'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag your buyer with 'OUTPUT_TAG_PREFIX_bid' 'is_greater_than' '0' to ensure the buyer is only routed when a bid is returned.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the LeadPortal API to request for a potential conversion bid and conversion timer. If the LeadPortal request returns a valid bid, Retreaver will open the LeadPortal integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the LeadPortal integrated buyer.\n\n2) Update the 'Ping URL' and 'Post URL' including: TEMPLATE_URL, TEMPLATE_KEY, TEMPLATE_ACTION, TEMPLATE_TYPE, TEMPLATE_SOURCE & TEMPLATE_TERMINATING_PHONE fields with the values provided by LeadPortal.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "leadportal_url",
                property_name: "LeadPortal URL",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "https://TEMPLATE_URL.leadportal.com/new_api/api.php"
            },
            {
                property_id: "api_key",
                property_name: "LeadPortal Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            },
            {
                property_id: "api_action",
                property_name: "LeadPortal API Action",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_ACTION"
            },
            {
                property_id: "type",
                property_name: "LeadPortal Type",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TYPE"
            },
            {
                property_id: "source",
                property_name: "LeadPortal Source",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            },
            {
                property_id: "terminating_phone",
                property_name: "LeadPortal Terminating Phone",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TERMINATING_PHONE"
            }
        ]
    },
    ringpartner_ping_post: {
        fields: {
            output_tag_prefix: 'ringpartner_12345',

            ping_url: 'https://api.rtcb.io/listings/search/?key=TEMPLATE_API_KEY&keyword=TEMPLATE_KEYWORD&zip=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"bid":"0.payout","timer":"0.conversionDuration","request_id":"0.requestId"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://api.rtcb.io/listings/callback/?api_key=TEMPLATE_API_KEY&request_id=<podd_start>request_id<podd_end>',
            post_method: 'GET',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '{}',
            post_output_map: '{"PostOutputMap":{"number":"number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the RingPartner API to request for a potential transfer number, conversion bid and conversion timer. If the RingPartner request returns a valid transfer number, Retreaver will open the RingPartner integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the RingPartner integrated buyer.\n\n2) Update the 'Ping URL' and 'Post URL' including: TEMPLATE_API_KEY, TEMPLATE_KEYWORD fields with the values provided by RingPartner.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "RingPartner Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "keyword",
                property_name: "RingPartner Keyword",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_KEYWORD"
            }
        ]
    },
    jangl_single_bid: {
        fields: {
            output_tag_prefix: 'jangl_12345',

            ping_url: 'https://calls-api.jangl.com/v1/single_bid',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Token TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"caller_phone":"[nanp_caller_number]","filters":{"currently_insured":"TEMPLATE_CURRENTLY_INSURED_VALUE"},"contact":{"zip_code":"[caller_zip]"}}',
            ping_output_map: '{"PingOutputMap":{"number":"phone_number","bid":"payout","timer":"purchase_duration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Jangl Single Bid API to request for a potential conversion bid. If the Jangl Single Bid request returns a valid conversion bid, Retreaver will open the Jangl integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Jangl integrated buyer.\n\n2) Update the 'Ping Header's 'TEMPLATE_AUTHORIZATION_TOKEN' with the value provided by Jangl.\n\n3) Update the 'Ping Data' 'TEMPLATE_CURRENTLY_INSURED_VALUE' field by hardcoding it as 'true' 'false' or place a Retreaver [replacement_token] in its place.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "currently_insured_value",
                property_name: "Jangl Currently Insured Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CURRENTLY_INSURED_VALUE"
            },
            {
                property_id: "authorization_token",
                property_name: "Jangl Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ]
    },
    dialpad_agent_availability: {
        fields: {
            output_tag_prefix: 'dialpad_12345',

            ping_url: 'https://dialpad.com/api/v2/callcenters/TEMPLATE_URL_CODE/status?apikey=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"capacity":"capacity","status":"availability.status"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_capacity' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_status' as the key, \n'equal' as the operator, \n'open' as the value.\n\n5) Press 'add' on the tag wizard.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the DialPad Agent Availability API to request a numeric 'capacity' response value representing the number of agents available to take a call. If the 'capacity' response value is above 0, Retreaver will open the DialPad integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the DialPad integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by DialPad.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "dialpad_url",
                property_name: "DialPad API Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://dialpad.com/api/v2/callcenters/TEMPLATE_URL_CODE/status?apikey=TEMPLATE_API_KEY"
            }
        ]
    },
    enrollhere_agent_availability_by_export: {
        fields: {
            output_tag_prefix: 'enrollhere_12345',

            ping_url: 'https://importer.enrollhere.com/export/data?channelId=TEMPLATE_CHANNEL_ID&userId=TEMPLATE_USER_ID&accessKey=TEMPLATE_ACCESS_KEY&filter_state=[caller_state]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"count":"data.count","available":"available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_count' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the EnrollHere Agent Availability API to request a numeric 'count' response value representing the number of agents available to take a call. If the 'count' response value is above 0, Retreaver will open the EnrollHere integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the EnrollHere integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by EnrollHere including the TEMPLATE_CHANNEL_ID,TEMPLATE_USER_ID & TEMPLATE_ACCESS_KEY values.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "channel_id",
                property_name: "EnrollHere Channel Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CHANNEL_ID"
            },
            {
                property_id: "user_id",
                property_name: "EnrollHere User Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_USER_ID"
            },
            {
                property_id: "access_key",
                property_name: "EnrollHere Access Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ACCESS_KEY"
            }
        ]
    },
    enrollhere_agent_availability: {
        fields: {
            output_tag_prefix: 'enrollhere_12345',

            ping_url: 'https://dialer-availability.enrollhere.com/dialer/availability/byQueue/TEMPLATE_QUEUEID?phone=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"count":"count","available":"available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_count' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the EnrollHere Agent Availability API to request a numeric 'count' response value representing the number of agents available to take a call. If the 'count' response value is above 0, Retreaver will open the EnrollHere integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the EnrollHere integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by EnrollHere including the TEMPLATE_QUEUEID value.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "queue_id",
                property_name: "EnrollHere Queue Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_QUEUEID"
            }
        ]
    },
    preping_agent_availability: {
        fields: {
            output_tag_prefix: 'preping_12345',

            ping_url: 'http://pre-ping.com/ls/mca/agentAvail.php?campaignID=TEMPLATE_CAMPAIGN_ID&state=[caller_state]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"status":"status","message":"message"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_message' as the key, \n'equals' as the operator, \n'Agent Available' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Pre-Ping Agent Availability API to request a text 'message' response value representing if agents are available to take a call. If the 'message' response value is 'Agent Available', Retreaver will open the Pre-Ping integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Pre-Ping integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Pre-Ping including the TEMPLATE_CAMPAIGN_ID value.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_id",
                property_name: "Pre-Ping Campaign Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ]
    },
    dnc_scrub: {
        fields: {
            output_tag_prefix: 'dncscrub',

            ping_url: 'https://www.dncscrub.com/app/main/rpc/scrub?phoneList=[nanp_caller_number]&version=5&output=json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded","loginId":"TEMPLATE_LOGIN_ID"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"result_code":"0.ResultCode"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_result_code' as the key, \n'matches' as the operator, \n'|C|E|Y|X|O|R|' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the DNC Scrub API to return a text 'result_code' response value representing if this lead is on a DNC (Do Not Call) list. If the 'result_code' response value is equal to any of the following: 'C,E,Y,X,O,R' - Retreaver will open the DNC Scrub integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Headers' field to include your DNC Scrub 'LoginId' by replacing the 'TEMPLATE_LOGIN_ID' value.\n\n2) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "login_id",
                property_name: "DNC Login ID",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_LOGIN_ID"
            }
        ]
    }
};
